// extracted by mini-css-extract-plugin
export default {"conflict":"schedule-conflict-modal_conflict__6V1Xb"};